import * as render from './render.pug'
import { useAuth } from '~vueutil/auth.js'
import { useToggle } from '~vueutil/useToggle.js'
import { vOnClickOutside } from '@vueuse/components'
import { AvatarMenu } from './menu/index.js'
import './style.css'

export default {
  ...render,
  props: { imgSrc: String, sex: String },
  components: {
    AvatarMenu
  },
  directives: {
    onClickOutside: vOnClickOutside
  },
  setup () {
    const auth = useAuth()
    const [show, toggle] = useToggle()
    return {
      auth,
      show,
      toggle,
      onClick () {
        if (auth.id) {
          // window.location.href = '/profile'
          toggle()
          return
        }

        const form = document.createElement('form')
        form.setAttribute('method', 'POST')
        form.setAttribute('action', '/auth/line')
        document.body.appendChild(form)
        form.submit()
        form.remove()
      }
    }
  }
}
